import { CssBaseline } from "@mui/material";
import PressLayout from "components/PressLayout";
import PressPage from "components/PressPage";
import Toolbox from "components/tools/Toolbox";
import CustomThemeProvider from "contexts/CustomThemeProvider";
import { ExperimentContextProvider } from "contexts/ExperimentContextProvider";
import { PageContextProvider } from "contexts/PageContextProvider";
import HomePage from "pages/HomePage";
import PageNotFound from "pages/PageNotFound";
import { Route, Routes } from "react-router-dom";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import "./App.css";

function App() {
  return (
    <ExperimentContextProvider>
      <PageContextProvider>
        <CustomThemeProvider>
          <CssBaseline />
          <Routes>
            <Route path="/" exact element={<HomePage />} />
            <Route
              path="press"
              element={<PressLayout />}
              children={<Route path=":id" element={<PressPage />} />}
            />
            <Route path="*" element={<PageNotFound />} />
          </Routes>
          {/* Tools only built in development mode */}
          {process.env.NODE_ENV === "development" && <Toolbox />}
        </CustomThemeProvider>
      </PageContextProvider>
    </ExperimentContextProvider>
  );
}

export default App;
